/**
 * Environment variable utilities
 */
export const env = {
  getString: (key: string, fallback: string): string => {
    return process.env[key] || fallback;
  },

  getInt: (key: string, fallback: number): number => {
    const value = process.env[key];
    return value ? parseInt(value, 10) : fallback;
  },
};
